var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 3L13 13","stroke":"currentColor","key":0}),React.createElement("path",{"d":"M13 3L3 13","stroke":"currentColor","key":1})]);
}

Close.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Close;

Close.default = Close;
